import axios, { AxiosRequestConfig } from 'axios'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { toAbsoluteUrl } from './_metronic/helpers'
import moment from 'moment'
import CryptoJS, { enc } from "crypto-js";
import { deleteCookie, getCookie, setCookie } from './_metronic/assets/ts/components/CookieComponent'
import { useLocation } from 'react-router-dom'
import { usePermissions } from './app/pages/contexts/PermissionContext'



export const FONTS = {
  bold: 'Poppins-Bold',
  black: 'Poppins-Black',
  regular: 'Poppins-Regular',
  medium: 'Poppins-Medium',
  semiBold: 'Poppins-SemiBold',
  semiItalic: 'Poppins-SemiBoldItalic',
  mediumItalic: 'Poppins-MediumItalic',
  italic: 'Poppins-Italic',
}




export const getEncodedCookie = (key: any) => {
  const encryptedKey = encodeURIComponent(encrypt(key));
  const cookie = getCookie(encryptedKey);
  return cookie && decrypt(cookie);
};

export const deleteEncodedCookie = (key: any) => {
  const encryptedKey = encrypt(key);
  deleteCookie(encryptedKey);

  //   return cookie && decrypt(cookie);
};

export const checkValue = (value: any) => {
  if (value != "" && value != null && value != undefined) {
    return value;
  } else {
    return "";
  }
};

export const setEncodedCookie = (key: any, value: any) => {
  let formattedValue;

  switch (typeof value) {
    case "object":
      formattedValue = JSON.stringify(value);
      break;
    case "number":
      formattedValue = String(value);
      break;
    default:
      formattedValue = value;
      break;
  }

  setCookie(encrypt(key), encrypt(formattedValue), {});
};

export const KEYS = {
  google_key: 'AIzaSyBcCBh1wLrK0wX_kGxxW2XBsZYfyFB9-40',
  PayPal_Client_ID: '',
  PayPal_Secret_key1: '',
}

export const SIZE = {
  font_11: 11,
  font_13: 13,
  font_15: 15,
  font_17: 17,
  font_20: 20,
}

export const COLORS = {
  darkGray: '#9A9999',
  borderClr: '#E8E6EA',
  pink: '#CB6CE6',
  lightGray: '#F5F5F5',
}

export const URL = {
  uatgogagnerurl: process.env.REACT_APP_UAT_GOGAGNER_URL,
}


export const fetchFormData = async (url: string, raw: any) => {
  var myHeaders: any = new Headers()
  var myHeaders: any = {
    apitoken: process.env.REACT_APP_API_TOKEN,
  }

  var requestOptions: any = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  }

  let response = await fetch(URL.uatgogagnerurl + url, requestOptions)

  let json = await response.json()

  return json
}

const uploadImage = async (file: any) => {
  const formData = new FormData()
  formData.append('file', file)

  try {
    const response = await axios.post(
      `${URL.uatgogagnerurl}vendor/public/descrptionImageUpload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )

    if (response.data.success) {
      return response.data.fileUrl // Adjust this based on your server response
    } else {
      console.error('Upload error:', response.data.message)
      return null
    }
  } catch (error) {
    console.error('Upload error:', error)
    return null
  }
}
export const config = (height?: number): any => {
  return {
    uploader: {
      insertImageAsBase64URI: false,
    },
    buttons: [
      'source',
      '|',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      'superscript',
      'subscript',
      '|',
      'ul',
      'ol',
      'outdent',
      'indent',
      '|',
      'font',
      'fontsize',
      'brush',
      'paragraph',
      '|',
      {
        name: 'image',
        exec: async function (editor: any) {
          const input = document.createElement('input') as any
          input.type = 'file'
          input.accept = 'image/*'
          input.onchange = async function () {
            const file = input.files[0]
            if (file) {
              const imageUrl = await uploadImage(file)
              if (imageUrl) {
                editor.selection.insertImage(imageUrl)
              }
            }
          }
          input.click()
        },
      },
      'table',
      'link',
      '|',
      'align',
      'undo',
      'redo',
      '|',
      'hr',
      'eraser',
      'copyformat',
      '|',
      'symbol',
      'fullsize',
      'print',
      'about',
    ],
    toolbarAdaptive: false,
    toolbarSticky: false,
    toolbarButtonSize: 'middle',
    showCharsCounter: true,
    showWordsCounter: true,
    showXPathInStatusbar: false,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: 'insert_clear_html',
    placeholder: '',

    // ✅ height param if provided, else fallback
    height: height ?? 300,
    minHeight: 200,
    maxHeight: 600,
  }
}

export const fetchData = async (url: string, raw: any, method: any = 'POST') => {
  var myHeaders: any = new Headers()
  var myHeaders: any = {
    apitoken: process.env.REACT_APP_API_TOKEN,
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }

  var requestOptions: AxiosRequestConfig = {
    method: method,
    url: URL.uatgogagnerurl + url,
    headers: myHeaders,
    data: JSON.stringify(raw),
  }

  const response = await axios(requestOptions)

  let json = await response.data

  return json
}

export const fetchData2 = async (
  url: string,
  raw: any,
  method: AxiosRequestConfig['method'] = 'POST'
) => {
  const myHeaders = {
    apitoken: process.env.REACT_APP_API_TOKEN || '',
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }

  const requestOptions: AxiosRequestConfig = {
    method,
    url: `${URL.uatgogagnerurl}${url}`,
    headers: myHeaders,
    data: raw,
  }

  try {
    const response = await axios(requestOptions)
    return response
  } catch (error) {
    console.error('API Error:', error)
    throw error // Re-throw to handle in the calling function
  }
}

export function toasterrormsg(message: any) {
  toast.error(message, {
    position: 'top-right',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'dark',
  })
}

export function toastsuccessmsg(message: any) {
  toast.success(message, {
    position: 'top-right',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'dark',
  })
}

export const truncateText = (text: any, maxLength = 10) =>
  text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

export const dateFormat = (date: any) => {
  const inputDate = new Date(date)

  if (date != undefined && date != null && date == '') {
    const year = inputDate.getFullYear()
    const month =
      inputDate.getMonth() + 1 > 9 ? inputDate.getMonth() + 1 : '0' + (inputDate.getMonth() + 1)
    const day = inputDate.getDate() > 9 ? inputDate.getDate() : '0' + inputDate.getDate()

    return `${year}-${month}-${day}`
  } else {
    return ''
  }
}

export const autopassword = () => {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+'
  let password = ''

  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length)
    password += charset.charAt(randomIndex)
  }

  return password
}

export function checkImageExists(url: any) {
  fetch(url, { method: 'HEAD' })
    .then((response) => {
      if (response.ok) {
        return url
      } else {
        return toAbsoluteUrl('/media/avatars/300-1.jpg')
      }
    })
    .catch(() => {
      return toAbsoluteUrl('/media/avatars/300-1.jpg')
    })
}

export const isOnlyNumber = (value: any) => {
  // Regular expression to match only numbers
  const regex = /^[0-9]+$/
  // Check if the value contains only numbers
  if (!regex.test(value)) {
    // Check if the value contains any alphabetic characters
    if (/^[a-zA-Z]+$/.test(value)) {
      // Value contains alphabetic characters, return false
      return false
    }
  }
  // Value contains only numbers or only alphabetic characters
  return true
}
export const isAlfabetsWithSpace = (value: any) => {
  // Regular expression to match only numbers
  const regex = /^[a-zA-Z ]+$/
  // Check if the value contains only numbers
  if (!regex.test(value)) {
    // Check if the value contains any alphabetic characters
    if (/^[0-9]+$/.test(value)) {
      // Value contains alphabetic characters, return false
      return false
    }
  }
  // Value contains only numbers or only alphabetic characters
  return true
}

export const hasSpecialCharacters = (value: any) => {
  // Regular expression to match special characters excluding spaces and English, Russian, and Uzbek language characters
  const specialCharacterRegex =
    /[^\w\u0020\u002C\u0430-\u044F\u0410-\u042F\u0401\u0451\u0493\u049B\u04E9\u04EF\u0513\u051B\u0523\u052B\u0533\u053B]/
  // Test if the value contains any special characters
  return !specialCharacterRegex.test(value)
}


// export const checkLanguage = (language:any , english:any , russian:any , uzbek:any ) => {
//  if(language === 'english') {
//   return english
//  }else if(language === 'russian') {
//   return russian
//  }else if(language === 'uzbek') {
//   return uzbek  }
// }


export const isOnlyAlphabetic = (value: any) => {
  // Regular expression to match only alphabetic characters and space
  const regex = /^[a-zA-Z\s]+$/
  // Check if the value contains only alphabetic characters and space
  return regex.test(value)
}

export const isSpecificSpecialCharacters = (value: any, customRegex?: RegExp) => {
  // Default regex (existing behavior)
  const defaultRegex = /^[a-zA-Z<>,."'*() ]*$/;

  // Use custom regex if provided, else default
  const regexToUse = customRegex || defaultRegex;

  return regexToUse.test(value);
};
export const limitLength = (value: any, maxLength: any) => {
  if (value.length <= maxLength) {
    return value // If the value is within the limit, return it unchanged
  } else {
    return value.slice(0, maxLength) + '...' // Otherwise, return a portion of the value with ellipsis
  }
}

export const googleMapKey = process.env.REACT_APP_GOOGLE_KEY

export function mysql_real_unescape_string(str: any): any {
  if (typeof str !== 'string') {
    return str
  } else {
    return str.replace(
      /\\0|\\b|\\t|\\z|\\n|\\r|\\"|\\'|\\\\|\\%/g,
      function (char: string): string {
        switch (char) {
          case '\\0':
            return '\0'
          case '\\b':
            return '\x08'
          case '\\t':
            return '\x09'
          case '\\z':
            return '\x1a'
          case '\\n':
            return '\n'
          case '\\r':
            return '\r'
          case '\\"':
            return '"'
          case "\\'":
            return "'"
          case '\\\\':
            return '\\'
          case '\\%':
            return '%'
          default:
            return char // return the char if it doesn't match any case
        }
      }
    )
  }
}

// export const formatNumber = (number: any) => {
//   return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
// }

export const checkwithremovemonth = (value: any, oldvalue: any) => {
  if (value.match(/^\d+$/) || value == '') {
    value = value.replace(/^0+(?=\d)/, '') || 0
    return value
  }
  return oldvalue
}

export const formatNumber = (number: any) => {

  if (number == null || number == undefined || isNaN(number)) {
    return '0 UZS'
  }
  const [integerPart, decimalPart] = number.toString().split('.')
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return decimalPart
    ? `${formattedInteger}.${decimalPart.slice(0, 2)} UZS`
    : formattedInteger + ' UZS'
}

export const getNumberOfDays = (fromDate: any, toDate: any) => {
  const start = moment(fromDate)
  const end = moment(toDate)
  // Calculate the difference in days
  const duration = end.diff(start, 'days')
  return duration
}
export const getNumberOfHours = (fromTime: any, toTime: any) => {
  const start = moment(fromTime, 'HH:mm:ss')
  const end = moment(toTime, 'HH:mm:ss')

  // Calculate the difference in hours
  const duration = end.diff(start, 'hours', true)

  return duration
}
export const getNumberOfHoursWithDateRange = (
  fromDate: string,
  fromTime: string,
  toDate: string,
  toTime: string
) => {
  const start = moment(`${fromDate} ${fromTime}`, 'YYYY-MM-DD HH:mm:ss')
  const end = moment(`${toDate} ${toTime}`, 'YYYY-MM-DD HH:mm:ss')

  // Calculate total duration in hours (can include fractions)
  const duration = end.diff(start, 'hours', true)

  return duration
}
export const getNumberOfHoursFromDateTime = (fromTime: any, toTime: any) => {
  const start = moment(fromTime, 'YYYY-MM-DD HH:mm:ss')
  const end = moment(toTime, 'YYYY-MM-DD HH:mm:ss')

  // Calculate the difference in hours
  const duration = end.diff(start, 'hours', true)

  return duration
}
export const getNumberOfHoursTime = (fromTime: any, toTime: any) => {
  const start = moment(fromTime, 'HH:mm:ss')
  const end = moment(toTime, 'HH:mm:ss')

  // Calculate the difference in hours
  const duration = end.diff(start, 'hours', true)

  return duration
}

export const handleTimeChange = (date: any, roundingInterval = 15) => {
  if (date && date.length > 0) {
    const selectedTime = moment(date[0]) // Get the first element if date is an array
    if (selectedTime.isValid()) {
      const roundedTime = selectedTime
        .minute(Math.round(selectedTime.minute() / roundingInterval) * roundingInterval)
        .second(0)
      return roundedTime.format('HH:mm') // Return the rounded time
    } else {
      console.error('Invalid date selected')
    }
  }
  return '00:00' // Return null if no valid date is selected
}


export function encryptAndEncode(input: string): string {
  return encodeURIComponent(encrypt(input));
}

export function decryptAndDecode(input: any): string {
  return decodeURIComponent(decrypt(input));
}


export const formatDate = (date: any, format: any) => {
  return moment(date).format(format)
}

export const formatDatePublic = (date: any) => {
  return moment(date).format("DD-MM-YYYY hh:mm A");
};

export const formattedMessage = (text: string): string => {
  return text.replace(/\n/g, '<br/>')
}

export const eLevel: any = {
  0: {
    "key": false,
    "value": false
  },
  1: {
    "key": false,
    "value": true
  },
  2: {
    "key": true,
    "value": true
  },
  3: {
    "key": true,
    "value": false
  },
}




export const getEncryptedRoute = (
  path: string,
  data: Record<string, any>, // accept any key-value object
  level: keyof typeof eLevel = '2'
): string => {
  const encrypted = encryptObject(data, eLevel[level])
  const encoded = encodeURIComponent(JSON.stringify(encrypted))
  return `${path}?data=${encoded}`
}

// get translation values

export const getTranslatedValue = (lang: any, propertyType: any, suffix: any, overridePrimaryLang?: any) => {
  const primaryToCode: any = {
    "English": "en",
    "Russian": "ru",
    "Uzbek": "uz"
  };
  const preferredKey = `${lang}${suffix}`;
  if (propertyType[preferredKey]) return propertyType[preferredKey];

  // Only fallback if primaryLanguage exists and is valid
  const primaryLang = overridePrimaryLang ?? propertyType.primaryLanguage ?? '';
  if (primaryLang && primaryToCode[primaryLang]) {
    const primaryCode = primaryToCode[primaryLang];
    const fallbackKey = `${primaryCode}${suffix}`;
    return propertyType[fallbackKey] || "";
  }
  // Directly return empty if no valid primaryLanguage
  return "";
};

export const useMenuIdPermissions = (level: keyof typeof eLevel = '2') => {
  const location = useLocation()
  const { permissions } = usePermissions() as any

  const queryParams = new URLSearchParams(location.search)
  const encryptedData = queryParams.get('data')

  let decryptedData: Record<string, any> = {}
  if (encryptedData) {
    try {
      decryptedData = decryptObject(
        JSON.parse(decodeURIComponent(encryptedData)),
        eLevel[level]
      )
    } catch (error) {
      console.error('Failed to decrypt data:', error)
    }
  }

  const menuId = decryptedData?.menuId

  return {
    urlData: decryptedData, // expose full data as `data`
    menuId,
    menuIdAdd: menuId && permissions?.menuIdAdd?.includes(menuId),
    menuIdEdit: menuId && permissions?.menuIdEdit?.includes(menuId),
    menuIdDelete: menuId && permissions?.menuIdDelete?.includes(menuId),
    menuIdView: menuId && permissions?.menuIdView?.includes(menuId),
  }
}

export const startPolling = (
  callback: () => void,
  interval: number
) => {
  let pollingInterval: NodeJS.Timeout | null = null;

  const adminData: any = sessionStorage.getItem("admin");
  let adminId = "";
  if (adminData) {
    adminId = JSON.parse(adminData).adminId || "";
  }

  const runCheck = () => {
    if (document.visibilityState === "visible" && adminId) {
      callback();
    }
  };

  const start = () => {
    runCheck(); // Run immediately
    pollingInterval = setInterval(runCheck, interval);
  };

  const stop = () => {
    if (pollingInterval) {
      clearInterval(pollingInterval);
      pollingInterval = null;
    }
  };

  // Stop polling when tab becomes hidden
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      stop();
    } else {
      start();
    }
  });

  start();

  return stop; // Allows manual stop if needed
};


const initVector = CryptoJS.enc.Utf8.parse("vOVH6sdmpNWjRRIq");

/**
 * Security key for AES encryption.
 * Should be set to a specific value.
 */
const Securitykey = CryptoJS.enc.Utf8.parse("vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3");

/**
   * Function to encrypt text using AES encryption.
    @param {} text - Text to be encrypted
   * @returns {string} - Encrypted text
   */
export const encrypt = (text: any) => {
  let cipher = CryptoJS.AES.encrypt(text, Securitykey, {
    iv: initVector,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });
  return cipher.toString();
};

/**
   * Function to decrypt text encrypted with AES encryption.
    @param {} encryptedText - Encrypted text
   * @returns {string} - Decrypted text
   */
export const decrypt = (encryptedText: any) => {
  let bytes = CryptoJS.AES.decrypt(encryptedText, Securitykey, {
    iv: initVector,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });
  return bytes.toString(CryptoJS.enc.Utf8);
};

/**
 * Function to recursively encrypt object properties based on encryption level.
 * Handles arrays within objects.
 * @param {object} obj - Object to encrypt
 * @param {object} keyLevel - Encryption level object with 'key' and 'value' properties
 * @returns {object} - Encrypted object
 */
export const encryptObject = (obj: any, keyLevel: any) => {
  const encryptedObject: any = {};
  const isKeyEncrypted = keyLevel["key"];
  const isValueEncrypted = keyLevel["value"];

  for (const [key, value] of Object.entries(obj)) {
    const encryptedKey = isKeyEncrypted ? encrypt(key) : key;

    if (Array.isArray(value)) {
      // Encrypt array elements
      encryptedObject[encryptedKey] = encryptArrayOfObjects(value, keyLevel);
    } else if (value instanceof Date) {
      // Encrypt Date objects as strings
      const encryptedValue = isValueEncrypted
        ? encrypt(value.toISOString())
        : value.toISOString();
      encryptedObject[encryptedKey] = encryptedValue;
    } else if (typeof value === "object" && value !== null) {
      // Recursively encrypt nested objects
      encryptedObject[encryptedKey] = encryptObject(value, keyLevel);
    } else if (typeof value === "string") {
      // Encrypt string values
      const encryptedValue = isValueEncrypted ? encrypt(value) : value;
      encryptedObject[encryptedKey] = encryptedValue;
    } else {
      // Leave other values unchanged
      encryptedObject[encryptedKey] = value;
    }
  }
  return encryptedObject;
};

/**
 * Function to encrypt an array recursively based on encryption level.
 * @param {Array} arr - Array to encrypt
 * @param {object} keyLevel - Encryption level object with 'key' and 'value' properties
 * @returns {Array} - Encrypted array
 */
export const encryptArrayOfObjects = (arr: any, keyLevel: any) => {
  return arr.map((item: any) => {
    if (Array.isArray(item)) {
      // Recursively encrypt nested arrays
      return encryptArrayOfObjects(item, keyLevel);
    } else if (typeof item === "object" && item !== null) {
      // Encrypt objects in the array
      return encryptObject(item, keyLevel);
    } else if (typeof item === "string" && keyLevel["value"]) {
      // Encrypt string items
      return encrypt(item);
    } else {
      // Leave other values unchanged
      return item;
    }
  });
};

/**
 * Function to decrypt an object recursively based on encryption level.
 * @param {object} obj - Encrypted object to decrypt
 * @param {{key: boolean, value: boolean}} keyLevel - Encryption level object with 'key' and 'value' properties
 * @returns {object} - Decrypted object
 */
export const decryptObject = (obj: any, keyLevel: any) => {
  const decryptedObject: any = {};
  const isKeyEncrypted = keyLevel["key"];
  const isValueEncrypted = keyLevel["value"];

  for (const [key, value] of Object.entries(obj)) {
    const decryptedKey = isKeyEncrypted ? decrypt(key) : key;

    if (Array.isArray(value)) {
      // Decrypt array elements
      decryptedObject[decryptedKey] = decryptArrayOfObjects(value, keyLevel);
    } else if (typeof value === "object" && value !== null) {
      // Recursively decrypt nested objects
      decryptedObject[decryptedKey] = decryptObject(value, keyLevel);
    } else if (typeof value === "string") {
      // Decrypt string values
      decryptedObject[decryptedKey] = isValueEncrypted ? decrypt(value) : value;
    } else {
      // Leave other values unchanged
      decryptedObject[decryptedKey] = value;
    }
  }

  return decryptedObject;
};

/**
 * Function to decrypt an array recursively based on encryption level.
 * @param {Array} arr - Encrypted array to decrypt
 * @param {{key: boolean, value: boolean}} keyLevel - Encryption level object with 'key' and 'value' properties
 * @returns {Array} - Decrypted array
 */
export const decryptArrayOfObjects = (arr: any, keyLevel: any) => {
  return arr.map((item: any) => {
    if (Array.isArray(item)) {
      // Recursively decrypt nested arrays
      return decryptArrayOfObjects(item, keyLevel);
    } else if (typeof item === "object" && item !== null) {
      // Decrypt objects in the array
      return decryptObject(item, keyLevel);
    } else if (typeof item === "string" && keyLevel["value"]) {
      // Decrypt string items
      return decrypt(item);
    } else {
      // Leave other values unchanged
      return item;
    }
  });
};
